import { IExtraGroup } from "../../../../interfaces/IExtraGroup";
import { IPreference } from "../../preferences/PreferenceForm";
import { IProductsContainerState } from "../ProductsContainer";
import { SET_CATEGORIES, SET_EXTRA_GROUPS, SET_IS_LOADING, SET_MENU_ITEMS, SET_PREFERENCE_GROUPS, SET_SUB_CATEGORIES, SET_TAGS, SET_VAT, UPDATE_MENU_ITEM_POSITION, UPDATE_SUBCATEGORY_POSITION , SET_TAXES } from "./productContainer.action";

export function ProductContainerReducer(state: IProductsContainerState, action: any) {
    switch (action.type) {
        case SET_CATEGORIES:
            return {
                ...state,
                categories: action.payload
            };
        case SET_SUB_CATEGORIES:
            return {
                ...state,
                subcategories: action.payload
            };
        case SET_VAT:
            return {
                ...state,
                vat: action.payload
            };
        case SET_TAXES:
            return {
                ...state,
                taxes: action.payload
            };
        case SET_MENU_ITEMS:
            return {
                ...state,
                menuItems: action.payload
            };
        case SET_IS_LOADING:
            return {
                ...state,
                isLoading: action.payload
            };
        case SET_EXTRA_GROUPS:
            const extraGroups = action.payload.sort((a: IExtraGroup, b: IExtraGroup) => a.name_public.localeCompare(b.name_public));
            return {
                ...state,
                extraGroups
            };
        case SET_PREFERENCE_GROUPS:
            const preferences = action.payload.sort((a: IPreference, b: IPreference) => a.name_public.localeCompare(b.name_public));
            return {
                ...state,
                preferences
            };
        case UPDATE_MENU_ITEM_POSITION:
            const menuItemState = state.menuItems;
            const newPosition = action.payload;
            let index = 0;
            for (const id of newPosition) {
                const productListIndex = menuItemState.findIndex((product) => product.id === id);
                if (productListIndex > -1) {
                    const newItem = {
                        ...menuItemState[productListIndex],
                        sort_position: index
                    }
                    menuItemState[productListIndex] = newItem;
                    index++;
                }
            }
            return {
                ...state,
                menuItems: [...menuItemState]
            }
        case UPDATE_SUBCATEGORY_POSITION:
            const subcatState = state.subcategories;
            const newSubPosition = action.payload;
            let i = 0;
            for (const id of newSubPosition) {
                const catListIndex = subcatState.findIndex((subcat) => subcat.id === id);
                if (catListIndex > -1) {
                    const newItem = {
                        ...subcatState[catListIndex],
                        sort_position: i
                    }
                    subcatState[catListIndex] = newItem;
                    i++;
                }
            }
            return {
                ...state,
                subcategories: [...subcatState]
            }
        case SET_TAGS:
            const tags = action.payload;
            return {
                ...state,
                tags
            }
        default:
            return {
                ...state,
            };
    }
}